




















import { Component, Vue, Prop } from 'vue-property-decorator'
import { PlayLog } from '@/class/game'
import Player from './Player.vue'

@Component({
  components: {
    Player
  }
})
export default class ReplayNightViewer extends Vue {
  @Prop() playLog!: PlayLog;

  get actorIds () {
    return this.playLog.actorIds
  }

  get targetIds () {
    return this.playLog.targetIds || [this.playLog.mafiaTargetId]
  }

  getBeforePlayer (playerId: string) {
    return this.playLog.beforePlayers[playerId]
  }
}
